<template>
  <div>
    <div class="item-block">
      <div class="left-side">
        <h3>{{ item.title }}</h3>
        <p class="description">{{ item.description }}</p>

        <router-link
          :to="{
            name: 'AllergenTable',
            query: { lang: this.$route.query.lang },
          }"
          class="nav-link"
        >
          <div class="allergen-group">
            <div
              class="allergen"
              v-for="allergen in item.allergens"
              :key="allergen"
            >
              <img
                :src="`https://madoheusden.be/img/${allergen}.png`"
                class="allergen-icon"
                :alt="allergen"
              />
            </div>
          </div>
        </router-link>
      </div>
      <div class="right-side">
        <p>{{ item.price }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ItemNew",
  components: {},
  props: {
    item: {
      type: Object,
      default() {
        return {
          id: 0,
          title: "",
          price: "",
          allergens: null,
        };
      },
    },
  },

  data() {
    return {
      isImageLoaded: false,
    };
  },
};
</script>

<style scoped>
.item-block {
  width: 90%;
  margin: 0 auto;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 5px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
}

.item-block h3 {
  font-size: 1.1rem;
  line-height: 1.5rem;
  text-transform: uppercase;
  font-weight: 600;
  color: black;
}

.description {
  font-size: 0.8rem;
  font-weight: lighter;
  color: grey;
}

.right-side p {
  margin: 0;
  color: #354b7c;
  font-size: 1.2rem;
  line-height: 1.5rem;
  font-weight: 400;
}

.left-side {
  text-align: left;
  max-width: 75%;
}

.right-side {
  display: flex;
  justify-content: center;
  align-items: center;
}

.allergen-group {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.allergen-icon {
  width: 14px;
  float: left;
  /* padding-left: 10%; */
}
</style>
